<template>
    <span>INFO</span>
</template>

<style scoped></style>

<script>
    export default {
        name: 'app-eventInfoTab',
        props: {},
        watch: {},
        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },
        data() {
            return {};
        },

        methods: {},
        computed: {},
    };
</script>
